import { isGuestMode, isDebugMockUser } from '../../methods/guestMode';

/******** Reducers ********/

// TODO: Remove mock user before production
const mockUser = {
  loggedIn: true,
  _id: 'test-user-123',
  id: 'test-user-123',
  fullName: 'Test User',
  email: 'test@example.com',
  image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=TestUser',
  accountType: 'pro',
  customerRole: { name: 'Professional' },
  notifications: [],
};

const guestUser = {
  loggedIn: true,
  isGuest: true,
  _id: 'guest-user-000',
  id: 'guest-user-000',
  fullName: 'AnyHomes Guest',
  email: 'guest@bookaroo.local',
  accountType: 'guest',
  customerRole: { name: 'Guest' },
  notifications: [],
};

const getInitialState = () => {
  if (isDebugMockUser()) return mockUser;
  if (isGuestMode()) return guestUser;
  return {
    loggedIn: false,
    notifications: [],
  };
};

const initialState = getInitialState();

export default function reducer(state = initialState, action) {
  // Un token d'authentification valide ⇒ utilisateur connecté : on ne doit
  // JAMAIS le traiter comme invité. Le flag `isGuest` persiste parfois après
  // une connexion via hydratation de token (LOGIN_SUCCESS sans token dans la
  // réponse) — ce qui faussait les droits (coach IA, etc.). On purge le flag.
  try {
    if (typeof window !== "undefined" && window.localStorage.getItem("token") && state && state.isGuest) {
      state = {
        ...state,
        isGuest: false,
        accountType: state.accountType === "guest" ? undefined : state.accountType,
        // Purge le placeholder invité : sinon `id`/`_id` restent « guest-user-000 »
        // et cassent les appels API (ex. listing off-market).
        _id: state._id === "guest-user-000" ? undefined : state._id,
        id: state.id === "guest-user-000" ? undefined : state.id,
      };
    }
  } catch (e) {
    /* ignore */
  }

  if (isDebugMockUser()) {
    if (!state || !state.loggedIn || state._id !== mockUser._id) {
      state = { ...mockUser };
    }
  } else if (isGuestMode()) {
    if (!state || !state.loggedIn || !state.isGuest || state._id !== guestUser._id) {
      state = { ...guestUser };
    }
  } else if (state && state.loggedIn) {
    // Si l'action en cours est un (vrai) login, on ne wipe pas l'état — la
    // case LOGIN_SUCCESS ci-dessous se chargera de nettoyer les flags guest.
    const isRealLoginAction = action && action.type === 'LOGIN_SUCCESS'
      && action.data && action.data.token && action.data.token !== 'mock-token';
    if (!isRealLoginAction) {
      const isPersistedMockUser = state.isGuest || state._id === 'test-user-123' || state.token === 'mock-token';
      if (isPersistedMockUser) {
        return {
          loggedIn: false,
          notifications: [],
        };
      }
    }
  }

  // Force le mock user uniquement si state vide ou non loggé
  if (isDebugMockUser() && (!state || !state.loggedIn)) {
    state = { ...mockUser };
  }
  if (isGuestMode() && (!state || !state.loggedIn || !state.isGuest)) {
    state = { ...guestUser };
  }
  switch (action.type) {
    case 'LOGIN_SUCCESS': {
      // Si un vrai login arrive (token réel, pas mock), on s'assure d'effacer
      // les flags guest hérités d'un éventuel guestUser persisté.
      const isRealLogin = action.data && action.data.token && action.data.token !== 'mock-token';
      const base = isRealLogin
        ? { ...state, isGuest: false, accountType: state?.accountType === 'guest' ? undefined : state?.accountType }
        : state;
      const merged = {
        ...base,
        loggedIn: true,
        ...action.data,
      };
      // Le placeholder invité « guest-user-000 » ne doit jamais survivre à une
      // connexion : on aligne `id` (legacy) sur le vrai `_id`.
      if (merged._id && merged._id !== 'guest-user-000') {
        if (!merged.id || merged.id === 'guest-user-000') merged.id = merged._id;
      } else if (merged.id === 'guest-user-000') {
        merged.id = undefined;
      }
      return merged;
    }
    case 'LOG_OUT':
      if (typeof window !== "undefined") {
        localStorage.removeItem('token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('persist:admin-app')
        // Déconnexion → la session de recherche (dernière recherche) est purgée.
        localStorage.removeItem('anyhomes_search_session')
      }
      return initialState;
    case 'ENTER_GUEST_MODE':
      return {
        ...guestUser,
      };
    case 'EXIT_GUEST_MODE':
      return {
        loggedIn: false,
        notifications: [],
      };
    default:
      return state;
  }
}
